var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 813.586,
    height: 97.318,
    viewBox: "0 0 813.586 97.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 813.586,
    height: 97.318,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M63.16.557H18.469V18.093H45.625v74.1H63.16v-74.1H90.316V.557Z",
    transform: "translate(75.787 2.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M84.338.557v38.46H53.217V.557H35.676V92.19H53.217V56.552H84.338V92.19h17.536V.557Z",
    transform: "translate(146.398 2.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M52.635.557V18.093h.02V39.017h-.02V56.552h.02v18.1h-.02V92.19H118.5V74.654H70.191v-18.1h39.031V39.017H70.191V18.093H118.5V.557Z",
    transform: "translate(215.985 2.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 17.536,
    height: 91.633,
    transform: "translate(623.619 2.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M130.619.557V92.19H186.2V74.654H148.154V.557Z",
    transform: "translate(535.991 2.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M174.01.557H144.7V92.19H174.01a45.816,45.816,0,0,0,0-91.633m0,74.1H162.237V18.1H174.01a28.278,28.278,0,0,1,0,56.557",
    transform: "translate(593.757 2.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M155.036,58.1a16.548,16.548,0,0,1-33.1,0V.558H104.4V58.1a34.084,34.084,0,1,0,68.167,0V.558H155.036Z",
    transform: "translate(428.42 2.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M131.433,29.372A28.817,28.817,0,0,0,102.614.558H69.487V92.191H87.023v-34h14.5l14.065,34h17.536l-15.76-38.1a28.783,28.783,0,0,0,14.065-24.721M87.023,18.094h15.065c5.655,0,10.84,3.919,11.672,9.513a11.185,11.185,0,0,1-11.146,13.044H87.023Z",
    transform: "translate(285.138 2.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M72.449,30.96a29.66,29.66,0,1,1-23.8-11.993V0A48.708,48.708,0,1,0,86.6,18.247Z",
    transform: "translate(0 0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M161.331,42.938H138.294V60.474h21.241a29.682,29.682,0,1,1-21.419-40.925l3.715-18.6a48.651,48.651,0,1,0,37.608,59.522c.189-.766.424-1.511.577-2.291a48.353,48.353,0,0,0,.567-15.244Z",
    transform: "translate(343.239 0.002)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.039d48db9675a06ae8730d17b19b218d.svg";
export { ForwardRef as ReactComponent };